<template>
  <section>
   <el-col :span="15" class="toolbar">
      <el-date-picker
        v-model="beginTime"
        type="datetime"
        placeholder="开始时间"
        size="small"
        format="yyyy-MM-dd HH:mm:ss">
      </el-date-picker>
      <el-date-picker
        v-model="endTime"
        type="datetime"
        placeholder="结束时间"
        size="small"
        format="yyyy-MM-dd HH:mm:ss">
      </el-date-picker>
        <el-select v-model="selectUserLevel" placeholder="请选择" size="small" style="width: 150px">
        <el-option key="200" label="会员等级" value="200"></el-option>
        <el-option
          v-for="(item, index) in huiyuanLevel"
          :key="index"
          :label="item"
          :value="index"
          size="small">
        </el-option>
      </el-select>
      <el-button type="primary"  size="small" @click="search">查询</el-button>
      <el-button size="small" @click="export2Excel">导出数据</el-button>
    </el-col>
    <el-col :span="6" class="toolbar rightsearch">
      <el-input placeholder="搜索" size="small" v-model="query" @change="search">
        <el-button slot="append" icon="search" @click="search"></el-button>
      </el-input>
    </el-col>
    <el-table :data="tableData" border v-loading="listLoading">
      <el-table-column label="ID" prop="usid" align="center">
      </el-table-column>
      <el-table-column label="微信名称" prop="name" align="center">
      </el-table-column>
      <el-table-column label="联系方式" prop="tel" align="center">
      </el-table-column>
      <el-table-column label="会员等级" prop="level" align="center">
          <template scope="scope">
              {{huiyuanLevel[scope.row.level]}}
          </template>
      </el-table-column>
      <el-table-column label="来源" prop="channel" align="center">
          <template scope="scope">
              {{huiyuanChannel[scope.row.channel]}}
          </template>
      </el-table-column>
      <el-table-column label="店铺名称" prop="dianpu_name" align="center">
      </el-table-column>
      <el-table-column label="五件批发" prop="five_pifa" align="center">
          <template scope="scope">
              {{supportStatus[scope.row.five_pifa]}}
          </template>
      </el-table-column>
      <el-table-column label="一件代发" prop="one_daifa" align="center">
          <template scope="scope">
              {{supportStatus[scope.row.one_daifa]}}
          </template>
      </el-table-column>
      <el-table-column label="购物车" prop="add_cart" align="center">
          <template scope="scope">
              {{supportStatus[scope.row.add_cart]}}
          </template>
      </el-table-column>
      <el-table-column label="用户状态" prop="user_status" align="center">
          <template scope="scope">
              {{verifyStatus[scope.row.user_status]}}
          </template>
      </el-table-column>
      <el-table-column label="最近登陆" prop="lately_at" align="center">
      </el-table-column>
      <el-table-column label="创建时间" prop="create_time" align="center">
      </el-table-column>
     
       <el-table-column label="审核时间" prop="verify_time" align="center">
      </el-table-column>
             <el-table-column label="白名单" prop="is_white" align="center">
          <template scope="scope">
                <el-button type="primary" v-if="scope.row.is_white == 0"  size="small" >正常客户</el-button>
                <el-button type="danger" v-if="scope.row.is_white == 1"  size="small" >白名单</el-button>
          </template>
      </el-table-column>
        <el-table-column label="备注" prop="remark" align="center">
      </el-table-column>
      <el-table-column label="操作" prop="labels" align="center">
        <template scope="scope">
          <el-button :plain="true" size="small" type="info" @click="verify(scope.row)">修改</el-button>
          <el-button :plain="true" size="small" type="info" @click="view(scope.row)">查看</el-button>
            <el-button :plain="true" type="info" size="small" @click="showOrder(scope.row.usid, '')">查看订单</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-col :span="0" class="toolbar_page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 15, 20, 30]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-col>

    <!--审核界面-->
    <el-dialog title="审核" v-model="verifyFormVisible" size="small">
        <el-form ref="userinfoForm" :model="userinfoForm" label-width="200px">
            <el-form-item label="会员等级" prop="level">
                <el-select v-model="userinfoForm.level" placeholder="请选择">
                    <el-option
                        v-for="(item, index) in huiyuanLevel"
                        :key="index"
                        :label="item"
                        :value="index"
                        size="small">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="来源" prop="channel">
                <el-select v-model="userinfoForm.channel" placeholder="请选择">
                    <el-option
                        v-for="(item, index) in huiyuanChannel"
                        :key="index"
                        :label="item"
                        :value="index"
                        size="small">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="五件批发" prop="five_pifa">
                <el-switch
                    v-model="userinfoForm.five_pifa"
                    on-color="#13ce66"
                    off-color="#bfcbd9"
                    on-value='1'
                    off-value='0'>
                </el-switch>
            </el-form-item>
            <el-form-item label="一件代发" prop="one_daifa">
                <el-switch
                    v-model="userinfoForm.one_daifa"
                    on-color="#13ce66"
                    off-color="#bfcbd9"
                    on-value='1'
                    off-value='0'>
                </el-switch>
            </el-form-item>
            <el-form-item label="加入购物车" prop="add_cart">
                <el-switch
                    v-model="userinfoForm.add_cart"
                    on-color="#13ce66"
                    off-color="#bfcbd9"
                    on-value='1'
                    off-value='0'>
                </el-switch>
            </el-form-item>
            <el-form-item label="审核状态" prop="user_status">
                <el-switch
                    v-model="userinfoForm.user_status"
                    on-color="#13ce66"
                    off-color="#bfcbd9"
                    on-value='1'
                    off-value='0'>
                </el-switch>
            </el-form-item>
            <el-form-item label="是否白名单" prop="is_white">
                <el-switch
                    v-model="userinfoForm.is_white"
                    on-color="#13ce66"
                    off-color="#bfcbd9"
                    on-value='1'
                    off-value='0'>
                </el-switch>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
                <el-input type="textarea" v-model="userinfoForm.remark" auto-complete="off" size="small" required></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click.native="verifySubmit" :loading="submitLoading">提交</el-button>
        </div>
    </el-dialog>

    <!--查看界面-->
    <el-dialog title="查看" v-model="viewFormVisible" size="large">
        <el-form ref="userinfoForm" :model="userinfoForm" label-width="100px">
            <el-row>
                <el-col :span="8">
                    <el-form-item label="微信编号" prop="open_id">
                        <el-input v-model="userinfoForm.dianpu_name"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="会员编号">
                        <el-input v-model="userinfoForm.name"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="性别">
                        <el-input v-model="sex"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="联系方式">
                        <el-input v-model="userinfoForm.tel"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="邮箱">
                        <el-input v-model="userinfoForm.email"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="用户等级">
                        <el-input v-model="level"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="来源">
                        <el-input v-model="channel"></el-input>
                    </el-form-item>
                    <el-form-item label="微信号">
                        <el-input v-model="userinfoForm.wechat_num"></el-input>
                    </el-form-item>
                    <el-form-item label="淘宝店/实体店">
                        <el-input v-model="userinfoForm.dianpu_name"></el-input>
                    </el-form-item>
                    <el-form-item label="地址">
                        <el-input v-model="address"></el-input>
                    </el-form-item>
                    <el-form-item label="身份证">
                        <el-input v-model="userinfoForm.card_num"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="营业图片">
                        <img v-if="userinfoForm.yingye_pic" :src="userinfoForm.yingye_pic" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6">
                    <el-form-item label="五件批发">
                        <el-switch
                            v-model="userinfoForm.five_pifa"
                            on-color="#13ce66"
                            off-color="#bfcbd9"
                            on-value='1'
                            off-value='0'>
                        </el-switch>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="一件代发">
                        <el-switch
                            v-model="userinfoForm.one_daifa"
                            on-color="#13ce66"
                            off-color="#bfcbd9"
                            on-value='1'
                            off-value='0'>
                        </el-switch>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="加入购物车">
                        <el-switch
                            v-model="userinfoForm.add_cart"
                            on-color="#13ce66"
                            off-color="#bfcbd9"
                            on-value='1'
                            off-value='0'>
                        </el-switch>
                    </el-form-item>
                </el-col>
                     <el-col :span="6">
                    <el-form-item label="用户状态">
                        <el-switch
                            v-model="userinfoForm.user_status"
                            on-color="#13ce66"
                            off-color="#bfcbd9"
                            on-value='1'
                            off-value='0'>
                        </el-switch>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="是否白名单">
                        <el-switch
                            v-model="userinfoForm.is_white"
                            on-color="#13ce66"
                            off-color="#bfcbd9"
                            on-value='1'
                            off-value='0'>
                        </el-switch>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item label="备注">
                <el-input type="textarea" v-model="userinfoForm.remark"></el-input>
            </el-form-item>
        </el-form>
    </el-dialog>
  </section>
</template>

<script>
  import config from '../../config';
  import {formatDate} from '../../static/js/date.js';
  import basicdata from '../../static/config/basicdata.js'
  
  export default {
    data() {
      return {
        tableData: [],
        total: 0,
        page: 1,
        pageSize: 15,
        listLoading: false,
        query: '',
        submitLoading: false,
        supportStatus: basicdata.supportStatus,
        verifyStatus: basicdata.verifyStatus,
        huiyuanLevel: basicdata.huiyuanLevel,
        huiyuanChannel: basicdata.huiyuanChannel,
        sexStatus: basicdata.sexStatus,
        selectUserLevel: "200",
        userinfoForm: {},
        verifyFormVisible: false,
        viewFormVisible: false,
        address: '',
        beginTime: '',
        endTime: '',
        sex: '',
        channel: '',
        level: ''
      }
    },
    methods: {
      //分页方法
      handleSizeChange(size) {
        this.pageSize = size;
        this.search();
      },
      handleCurrentChange(page) {
        this.page = page;
        this.search();
      },
      search() {
        this.getSearch(this.query);
      },
      getSearch(query) {
        this.listLoading = true;
        this.beginTime = typeof(this.beginTime) != "string" ? formatDate(this.beginTime, "yyyy-MM-dd hh:mm:ss") : this.beginTime;
        this.endTime = typeof(this.endTime) != "string" ? formatDate(this.endTime, "yyyy-MM-dd hh:mm:ss") : this.endTime;
        query = this.beginTime + "|" + this.endTime + "|"  + this.selectUserLevel+ "|"+ query;
        this.$axios.post(config.api_url + '/userinfo/page', {
          "page": this.page,
          "size": this.pageSize,
          "query": query
        }).then(response => {
          let data = response.data;
          if (data.state) {
            this.total = data.count;
            this.tableData = data.msg;
            this.listLoading = false;
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取数据异常，请联系管理员',
            type: 'error'
          });
        })
      },
        // 导出Excel
      export2Excel() {
        this.beginTime = typeof(this.beginTime) != "string" ? formatDate(this.beginTime, "yyyy-MM-dd hh:mm:ss") : this.beginTime;
        this.endTime = typeof(this.endTime) != "string" ? formatDate(this.endTime, "yyyy-MM-dd hh:mm:ss") : this.endTime;
        // if(!this.beginTime || !this.endTime) {
        //   this.$message({
        //     message: '时间不能为空！',
        //     type: 'warning'
        //   });
        //   return;
        // }
        this.$axios.get(config.api_url + '/userinfo/excel/'+this.beginTime+'/'+this.endTime+"/"  + this.selectUserLevel
        ).then(response => {
          if(response.data.state) {
            if(response.data.msg) {
              console.log(response.data.msg);
              require.ensure([], () => {
                const { export_json_to_excel } = require('../../static/vendor/Export2Excel');
                const tHeader = ['用户编号', '微信名称', '联系方式', '来源', '  店铺名称', '最近登陆', '创建时间', '备注']; //对应表格输出的title
                const filterVal = ['usid', 'name', 'tel', 'channel', 'dianpu_name', 'lately_at', 'create_time', 'remark']; // 对应表格输出的数据
                const list = response.data.msg;
                const data = this.formatJson(filterVal, list);
                export_json_to_excel(tHeader, data, '用户列表_'+this.beginTime+'_'+this.endTime); //对应下载文件的名字
              });
            } else {
              this.$message({
                message: '无数据，请联系管理员！',
                type: 'warning'
              });
            }
          } else {
            this.$message({
              message: '无数据，请联系管理员！',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '导出异常，请联系管理员！',
            type: 'error'
          });
        });
      },
         formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]));
      },
    //   审核
      verify(row){
          this.userinfoForm = row;
          this.userinfoForm.level = row.level.toString();
          this.userinfoForm.channel = row.channel.toString();
          this.userinfoForm.five_pifa = row.five_pifa.toString();
          this.userinfoForm.one_daifa = row.one_daifa.toString();
          this.userinfoForm.add_cart = row.add_cart.toString();
          this.userinfoForm.user_status = row.user_status.toString();
          this.userinfoForm.is_white = row.is_white.toString();
          this.verifyFormVisible = true;
      },
        showOrder(usid, orderNum) {
        this.$router.push('/order/list/'+usid+'/'+orderNum);
      },
      verifySubmit() {
        this.$confirm('确认提交吗？', '提示', {}).then(() => {
            this.submitLoading = true;
            let para = Object.assign({}, this.userinfoForm);
            para.level = parseInt(para.level);
            para.channel = parseInt(para.channel);
            para.five_pifa = parseInt(para.five_pifa);
            para.one_daifa = parseInt(para.one_daifa);
            para.add_cart = parseInt(para.add_cart);
            para.user_status = parseInt(para.user_status);
             para.is_white = parseInt(para.is_white);
            //异步请求
            this.$axios.put(config.api_url + '/userinfo',
            para).then(response => {
                if (response.data.state) {
                    this.$message({
                        message: '提交成功',
                        type: 'success'
                    });
                    this.verifyFormVisible = false;
                    this.search();
                } else {
                    this.$message({
                        message: '提交失败，请联系管理员',
                        type: 'error'
                    });
                }
            }).catch(error => {
                console.log(error);
                this.$message({
                    message: '提交异常，请联系管理员',
                    type: 'error'
                });
            });
            this.submitLoading = false;
        });
      },
  
    //   查看
      view(row) {
          this.userinfoForm = row;
          this.address = row.sheng+'-'+row.shi+'-'+row.xian;
          this.sex = this.sexStatus[row.sex];
          this.channel = this.huiyuanChannel[row.channel];
          this.level = this.huiyuanLevel[row.level];
          this.userinfoForm.five_pifa = row.five_pifa.toString();
          this.userinfoForm.one_daifa = row.one_daifa.toString();
          this.userinfoForm.add_cart = row.add_cart.toString();
          this.userinfoForm.user_status = row.user_status.toString();
          this.userinfoForm.is_white = row.is_white.toString();
          this.viewFormVisible = true;
      }
    },
    created() {
      this.search();
    }
  }
</script>

<style scoped>
  .rightsearch {
    float: right;
  }
  .avatar {
     width: 245px;
    height: 265px;
  }
</style>



// WEBPACK FOOTER //
// huiyuan.vue?5775b243